export default (total, limit) => {
  return Math.ceil((total / limit))
}
